import React from 'react';
import styles from '../styles/dashboard.module.css';
import { CheckIcon } from '@heroicons/react/24/solid';
import logo from '../../../assets/images/DtpLogoSmall.webp';

const FeaturePoup = ({closePopup}) => {
    return (
        <div className={styles.infoPopup}>
            <p className={styles.dismiss} onClick={closePopup}>x</p>
            <img src={logo} alt="dtp_logo_icon" width={100} />
            <div className={styles.featureContainer}>
                <ul className={styles.featureList}>
                    <li >
                        <p className={styles.feature}>Track <span className="hightLightText">5</span> devices at once</p><CheckIcon className={styles.featureIcon} />
                    </li>
                    <li>
                        <p className={styles.feature}><span className="hightLightText">Unlimited</span> tracking</p><CheckIcon className={styles.featureIcon} />
                    </li>
                    <li >
                        <p className={styles.feature}>Up to <span className="hightLightText">30 days</span> location history</p><CheckIcon className={styles.featureIcon} />
                    </li>
                    <li >
                        <p className={styles.feature}>Track <span className="hightLightText">Apple & Android</span></p><CheckIcon className={styles.featureIcon} />
                    </li>
                    <li >
                        <p className={styles.feature}>Works on <span className="hightLightText">all networks</span></p><CheckIcon className={styles.featureIcon} />
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default FeaturePoup